var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ratio"},[_c('span',{staticClass:"win"},[_vm._v(_vm._s(_vm.win))]),_c('span',{staticClass:"lose"},[_vm._v(_vm._s(_vm.lose))]),_c('img',{staticClass:"icon",attrs:{"src":require("./assets/ratio.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }